const semanticTokens = {
  colors: {
    error: {
      default: "red.500",
      _dark: "red.600",
      _hover: "red.600",
    },
    success: {
      default: "green.500",
      _dark: "green.600",
      _hover: "green.600",
    },
    primary: {
      default: "seaGreen.500",
      _dark: "seaGreen.600",
      _hover: "seaGreen.600",
    },
    secondary: {
      default: "gray.500",
      _dark: "gray.600",
      _hover: "gray.600",
    },
    text: {
      default: "gray.500",
      _dark: "gray.600",
      _hover: "gray.600",
    },
  },
};

export default semanticTokens;
